// Security Audit jobs: Kyle's answer to a cascade decision is his call on that foreign key for the whole system,
// saved in security_cascade_calls so no later audit asks about it again. Called wherever decision answers are saved
// (answerSpecDecision, approveSpec). "Later" and un-answering leave any saved call alone.

import { supabase } from './supabase';
import type { AiJob } from './supabase.types';

const CALL_FOR_ANSWER: Record<string, 'good' | 'bad'> = { 'Good cascade, keep': 'good', 'Change it': 'bad' };

export async function recordCascadeCalls(job: AiJob, answers: Record<string, string | null>): Promise<void> {
  if (job.task_type !== 'security_audit' || !job.security_system_id) return;
  const findings = job.operator_summary?.spec?.findings ?? [];
  const rows = findings
    .filter((f) => f.bucket === 'cascade' && f.cascade && answers[f.decision_id] && CALL_FOR_ANSWER[answers[f.decision_id] as string])
    .map((f) => ({
      system_id: job.security_system_id as string,
      constraint_name: f.cascade!.constraint_name,
      from_table: f.cascade!.from_table,
      to_table: f.cascade!.to_table,
      call: CALL_FOR_ANSWER[answers[f.decision_id] as string],
      note: f.cascade!.why,
    }));
  if (!rows.length) return;
  const { data: auth } = await supabase.auth.getUser();
  const at = new Date().toISOString();
  const { data, error } = await supabase
    .from('security_cascade_calls')
    .upsert(rows.map((r) => ({ ...r, decided_by: auth.user?.id ?? null, decided_at: at })), { onConflict: 'system_id,constraint_name' })
    .select('id');
  if (error) throw new Error(`The answer is saved, but the cascade call wasn't: ${error.message}`);
  if ((data ?? []).length < rows.length) throw new Error("The answer is saved, but the cascade call wasn't (admins only).");
}
